import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import { RHFTextField } from '@openx/components-core/lib/TextField/RHFTextField.tsx';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

type RangeFieldGroupProps = {
  from: string;
  to: string;
  prefix?: string;
  suffix?: string;
  labelFrom: string;
  labelTo: string;
  dataTest?: string;
};

export const RangeFieldGroup = ({ from, to, prefix, suffix, labelFrom, labelTo, dataTest }: RangeFieldGroupProps) => {
  const { trigger } = useFormContext();

  useEffect(() => {
    trigger([from, to]);
  }, [trigger, from, to]);

  const sharedProps = {
    slotProps: {
      input: {
        disableUnderline: true,
        startAdornment: prefix ? <InputAdornment position="start">{prefix}</InputAdornment> : undefined,
        endAdornment: suffix ? <InputAdornment position="end">{suffix}</InputAdornment> : undefined,
      },
      inputLabel: { disableAnimation: true, focused: false, shrink: true },
    },
    placeholder: '0.00',
    sx: {
      '& input': { border: 'none !important' },
      '& .MuiInputAdornment-root': { mx: 1 },
      '& .MuiInputBase-root': {
        border: '1px solid',
        borderRadius: '2px',
        borderColor: 'divider',
      },
      width: '100%',
    },
  };

  return (
    <Grid container sx={{ width: '100%' }} spacing={2} key={`${from}-${to}`}>
      <Grid size={6}>
        <RHFTextField {...sharedProps} name={from} label={labelFrom} dataTest={`${dataTest}-from`} />
      </Grid>
      <Grid size={6}>
        <RHFTextField {...sharedProps} name={to} label={labelTo} dataTest={`${dataTest}-to`} />
      </Grid>
    </Grid>
  );
};
